import { format,parse,differenceInSeconds } from 'date-fns';

export class DriveScheduleRest {
    id:any = 0;
    idRow:any = 0;
    idxRow:number = -1;
    dtgUnitId:string = "";
    dtgRegDt:string = "";
    dtgRegDtYy:number = 0;
    dtgRegDtMm:number = 0;
    dtgRegDtDd:number = 0;
    dtgRegDtHh:number = 0;
    dtgRegDtFrom:string = "";
    dtgRegDtTo:string = "";
    dtgCarNo:string = "";
    dtgCarType:string = "";
    dtgCarTypeNm:string = "";
    userId:string = "";
    userNm:string = "";
    companyId:string;
    companyNm:string;
    dtFromRest:string = "";
    dtToRest:string = "";
    durSecRest:number = 0;
    durMinuteRest:number = 0;
    import(resItem){
        for(let key1 in resItem){
            if(this.hasOwnProperty(key1) === true){
                this[key1] = resItem[key1];
            }
        }
        this.dtFromRest = this.dtgRegDtFrom;// 휴식 시작일시 (운행종료일시)
        this.dtToRest = this.dtgRegDtTo;// 휴식 종료일시 (운행종료일시) -> 다음 운행 시작일시로 업데이트
    };
    getDtFromRestDate(){
        return parse(this.dtFromRest,"yyyy-MM-dd HH:mm:ss",new Date());//휴식시작
    };
    getDtToRestDate(){
        return parse(this.dtToRest,"yyyy-MM-dd HH:mm:ss",new Date());//휴식종료
    };
    getDtFromRestTxt(){
        return this.dtFromRest;
    };
    getDtToRestTxt(){
        return this.dtToRest;
    };
    getDurSecRest(){
        return differenceInSeconds(this.getDtToRestDate(),this.getDtFromRestDate());
    };
    getDurMinuteRest(){
        return Math.floor(this.getDurSecRest() / 60);
    };
}